import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

api.interceptors.response.use(
 (response) => {
 return response;
 },
 (error) => {
 return Promise.reject(error);
 }
);

export default api;
